module.exports = __webpack_public_path__ + "static/media/ups_logo_new.a5872954.png";